import { render, staticRenderFns } from "./PayoutAccountsForm.vue?vue&type=template&id=64a47776&scoped=true&"
import script from "./PayoutAccountsForm.vue?vue&type=script&lang=js&"
export * from "./PayoutAccountsForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=64a47776&scoped=true&lang=css&"
import style1 from "./PayoutAccountsForm.vue?vue&type=style&index=1&id=64a47776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a47776",
  null
  
)

export default component.exports